<template>
    <content-view class="showdata">
        <div class="bg-white pl32 pr32 pt32">
            <a-checkbox-group
                v-model="checkboxValue"
                name="checkboxgroup"
                :options="weekListData"
                @change="checkboxchange"
            />
            <div style="margin-top: 30px">
                <a-tabs v-model="activeKey" @change="tabschange">
                    <a-tab-pane :key="0">
                        <template #tab>
                            <span> 默认展示 </span>
                        </template>
                    </a-tab-pane>
                    <a-tab-pane
                        v-for="item in weekListData"
                        :key="item.value * 1"
                    >
                        <template #tab>
                            <span> {{ item.label }} </span>
                        </template>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <a-form-model ref="formRef" :model="form" :rules="rules">
                <div class="text-black-85 font-big bold pb24">今日回收数据</div>
                <a-form-model-item
                    class="form-item"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.start_weight"
                >
                    <template v-slot:label>
                        <span>回收总量</span>
                        <span style="color: skyblue">当前值</span>
                    </template>
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.start_weight"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.end_weight"
                >
                    <template v-slot:label>
                        <span>回收总量</span>
                        <span style="color: skyblue">最终值</span>
                    </template>
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.end_weight"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="纸类:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.paper"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.paper"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="塑料:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.plastic"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.plastic"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="金属:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.metal"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.metal"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="纺织:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.textile"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.textile"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="玻璃:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.glass"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.glass"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="家电:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_cate_data.electrical"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.today_cate_data.electrical"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <div v-if="false">
                    <div class="text-black-85 font-big bold pb24">
                        今日回收排行榜
                    </div>
                    <a-form-model-item
                        class="form-item"
                        :labelCol="{ span: 3 }"
                        :wrapperCol="{ span: 8 }"
                        :colon="false"
                        v-for="(item, index) in form.today_rank"
                        :key="'回收排行榜' + index"
                    >
                        <template v-slot:label>
                            <span class="circle-wrapper">{{ item.sort }}</span>
                        </template>
                        <a-row type="flex">
                            <a-col :span="3">
                                <template v-if="item.name == ''">——</template>
                                <template v-else>{{ item.name }}</template>
                            </a-col>
                            <a-col :span="5">
                                <a-input
                                    placeholder="请输入"
                                    v-model="item.weight"
                                    @change="
                                        inputChangetr(
                                            index,
                                            (errtr[index].err = 1)
                                        )
                                    "
                                />
                            </a-col>
                            <a-col :span="2" class="ml8"> 吨 </a-col>
                            <a-col :span="2" class="ml8">
                                <a-button
                                    type="dashed"
                                    v-if="item.name == ''"
                                    @click="today(index)"
                                    >+添加点位</a-button
                                >
                                <a-button
                                    type="dashed"
                                    v-else
                                    @click="today(index)"
                                    >+替换点位</a-button
                                >
                            </a-col>
                            <a-col
                                :span="2"
                                style="margin-left: 64px; white-space: nowrap"
                            >
                                <span
                                    style="color: red"
                                    v-if="
                                        errtr[index].err == 2 ||
                                        errtr[index].blockerr == 2
                                    "
                                >
                                    请填写信息
                                </span>
                                <span v-else></span>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                    <div class="text-black-85 font-big bold pb24">
                        居民参与率排行
                    </div>
                    <a-form-model-item
                        class="form-item"
                        :labelCol="{ span: 3 }"
                        :wrapperCol="{ span: 8 }"
                        :colon="false"
                        v-for="(item, index) in form.join_rate"
                        :key="'参与率排行' + index"
                    >
                        <template v-slot:label>
                            <span class="circle-wrapper">{{ item.sort }}</span>
                        </template>
                        <a-row type="flex">
                            <a-col :span="3">
                                <template v-if="item.name == ''">——</template>
                                <template v-else>{{ item.name }}</template>
                            </a-col>
                            <a-col :span="5">
                                <a-input
                                    placeholder="请输入"
                                    v-model="item.rate"
                                    @change="
                                        inputChangejr(
                                            index,
                                            (errjr[index].err = 1)
                                        )
                                    "
                                />
                            </a-col>
                            <a-col :span="2" class="ml8"> % </a-col>
                            <a-col :span="2" class="ml8">
                                <a-button
                                    type="dashed"
                                    v-if="item.name == ''"
                                    @click="rate(index)"
                                    >+添加点位</a-button
                                >
                                <a-button
                                    type="dashed"
                                    v-else
                                    @click="rate(index)"
                                    >+替换点位</a-button
                                >
                            </a-col>
                            <a-col
                                :span="2"
                                style="margin-left: 64px; white-space: nowrap"
                            >
                                <span
                                    style="color: red"
                                    v-if="
                                        errjr[index].err == 2 ||
                                        errjr[index].blockerr == 2
                                    "
                                >
                                    请填写信息
                                </span>
                                <span v-else></span>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </div>
                <div class="text-black-85 font-big bold pb24">今日回收人员</div>
                <a-form-model-item
                    class="form-item"
                    label="总人数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_people.total"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.today_people.total"
                    />
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="在线人数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="today_people.online"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.today_people.online"
                    />
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">回收站点</div>
                <a-form-model-item
                    class="form-item"
                    label="站点总数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="station.total"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.station.total"
                    />
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="营业数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="station.online"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.station.online"
                    />
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">物流车</div>
                <a-form-model-item
                    class="form-item"
                    label="车辆总数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="cars.total"
                    :colon="false"
                >
                    <a-input placeholder="请输入" v-model="form.cars.total" />
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="在线数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="cars.online"
                    :colon="false"
                >
                    <a-input placeholder="请输入" v-model="form.cars.online" />
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">
                    <div>
                        <span>车辆行驶轨迹</span>
                        <a-button style="margin-left: 20px" @click="addClick"
                            >+添加</a-button
                        >
                    </div>
                </div>
                <div style="width: 60%">
                    <a-table :columns="tablecolumns" :data-source="tabledata">
                        <template
                            slot="action"
                            slot-scope="text, record, index"
                        >
                            <span
                                style="color: blue; cursor: pointer"
                                @click="deleteTable(index)"
                                >删除</span
                            >
                        </template>
                    </a-table>
                </div>
                <div class="text-black-85 font-big bold pb24">分拣中心</div>
                <a-form-model-item
                    class="form-item"
                    label="总数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="sorting.total"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.sorting.total"
                    />
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="营业"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="sorting.online"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.sorting.online"
                    />
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">打包站</div>
                <a-form-model-item
                    class="form-item"
                    label="总数"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="pack_station.total"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.pack_station.total"
                    />
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="营业"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="pack_station.online"
                    :colon="false"
                >
                    <a-input
                        placeholder="请输入"
                        v-model="form.pack_station.online"
                    />
                </a-form-model-item>

                <div class="text-black-85 font-big bold pb24">
                    近一年回收数据
                </div>
                <a-form-model-item
                    class="form-item"
                    label="回收总量:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.total"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.total"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="纸类:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.paper"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.paper"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="塑料:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.plastic"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.plastic"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="金属:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.metal"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.metal"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="纺织:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.textile"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.textile"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="玻璃:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.glass"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.glass"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="家电:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_recycling.electrical"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_recycling.electrical"
                        />
                        <span class="ml8">%</span>
                    </div>
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">
                    近一年每月回收数据
                </div>
                <a-form-model-item
                    class="form-item"
                    label="一月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.january"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.january"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="二月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.february"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.february"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="三月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.march"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.march"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="四月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.april"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.april"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="五月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.may"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.may"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="六月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.june"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.june"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="七月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.july"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.july"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="八月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.august"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.august"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="九月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.september"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.september"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="十月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.october"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.october"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="十一月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.november"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.november"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="十二月:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_year_per_month.december"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_year_per_month.december"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>

                <div class="text-black-85 font-big bold pb24">
                    近一月回收排行榜
                </div>
                <a-form-model-item
                    class="form-item"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 8 }"
                    :colon="false"
                    v-for="(item, index) in form.last_month_rank"
                    :key="'榜' + index"
                >
                    <template v-slot:label>
                        <span class="circle-wrapper">{{ item.sort }}</span>
                    </template>
                    <a-row type="flex">
                        <a-col :span="3">
                            <template v-if="item.name == ''">——</template>
                            <template v-else>{{ item.name }}</template>
                        </a-col>
                        <a-col :span="5">
                            <a-input
                                placeholder="请输入"
                                v-model="item.weight"
                                @change="
                                    inputChangelr(index, (errlr[index].err = 1))
                                "
                            />
                        </a-col>
                        <a-col :span="2" class="ml8"> 吨 </a-col>
                        <a-col :span="2" class="ml8">
                            <a-button
                                type="dashed"
                                v-if="item.name == ''"
                                @click="last(index)"
                                >+添加点位</a-button
                            >
                            <a-button type="dashed" v-else @click="last(index)"
                                >+替换点位</a-button
                            >
                        </a-col>
                        <a-col
                            :span="2"
                            style="margin-left: 64px; white-space: nowrap"
                        >
                            <span
                                style="color: red"
                                v-if="
                                    errlr[index].err == 2 ||
                                    errlr[index].blockerr == 2
                                "
                            >
                                请填写信息
                            </span>
                            <span v-else></span>
                        </a-col>
                    </a-row>
                </a-form-model-item>
                <div class="text-black-85 font-big bold pb24">
                    近一周每日居民平均回收量
                </div>
                <a-form-model-item
                    class="form-item"
                    label="星期一:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.monday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.monday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期二:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.tuesday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.tuesday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期三:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.wednesday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.wednesday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期四:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.thursday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.thursday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期五:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.friday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.friday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期六:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.saturday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.saturday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item
                    class="form-item"
                    label="星期日:"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 5 }"
                    prop="last_week_avg_weight.sunday"
                >
                    <div style="display: flex">
                        <a-input
                            placeholder="请输入"
                            v-model="form.last_week_avg_weight.sunday"
                        />
                        <span class="ml8">吨</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item class="text-center footerButton pt24">
                    <a-button type="primary" @click="handleSubmit">
                        保 存
                    </a-button>
                </a-form-model-item>
            </a-form-model>
            <a-modal
                title="添加点位"
                :visible="visible"
                @ok="handleOk"
                @cancel="handleCancel"
                width="50%"
            >
                <template>
                    <reset-search
                        class="pb16 pt16"
                        ref="pa"
                        :form.sync="blockForm"
                    >
                        <table class="wh-form wh-form_full">
                            <tbody>
                                <tr>
                                    <td width="70">网点名称：</td>
                                    <td>
                                        <a-input
                                            v-model="blockForm.name"
                                            placeholder="请输入"
                                        ></a-input>
                                    </td>
                                    <td class="text-center">
                                        <a-button @click="reset" class="mr8"
                                            >重 置
                                        </a-button>
                                        <a-button type="primary" @click="search"
                                            >查 询
                                        </a-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </reset-search>
                    <a-table
                        :columns="columns"
                        :dataSource="blockList"
                        :rowKey="(record) => record.id"
                        bordered
                        class="mt16"
                        size="middle"
                        :pagination="pagination"
                        @change="pageChange"
                        :row-selection="{
                            type: 'radio',
                            selectedRowKeys: selectedRowKeys,
                            onChange: onSelectChange,
                        }"
                    >
                    </a-table>
                </template>
            </a-modal>
            <!-- 行驶轨迹列表弹窗 -->
            <a-modal
                v-model="transportopen"
                title="添加车辆行驶轨迹"
                @ok="transporthandleOk"
                width="50%"
            >
                <reset-search
                    class="pb32 pt16"
                    ref="pa"
                    :form.sync="addtransportFrom"
                >
                    <table class="wh-form wh-form_full">
                        <tbody>
                            <tr>
                                <td width="70">运单号：</td>
                                <td>
                                    <a-input
                                        v-model="addtransportFrom.serial"
                                        placeholder="请输入"
                                    ></a-input>
                                </td>
                                <td width="70">车牌号：</td>
                                <td>
                                    <a-input
                                        v-model="addtransportFrom.car_number"
                                        placeholder="请输入"
                                    ></a-input>
                                </td>
                                <td width="70">目的地：</td>
                                <td>
                                    <a-input
                                        v-model="
                                            addtransportFrom.sorting_address
                                        "
                                        placeholder="请输入"
                                    ></a-input>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center" colspan="6">
                                    <a-button
                                        @click="transportreset"
                                        class="mr8"
                                        >重 置
                                    </a-button>
                                    <a-button
                                        type="primary"
                                        @click="transportsearch"
                                        >查 询
                                    </a-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </reset-search>
                <a-table
                    :columns="transportcolumns"
                    :data-source="transportdata"
                    :pagination="transportpagination"
                    @change="transportpageChange"
                    bordered
                >
                    <template slot="check" slot-scope="text, record">
                        <a-checkbox v-model="record.checked"></a-checkbox>
                    </template>
                    <template slot="distance" slot-scope="text, record">
                        <span
                            style="color: blue; cursor: pointer"
                            @click="detailsClick(record)"
                            >{{ text }}</span
                        >
                    </template>
                </a-table>
            </a-modal>
            <!-- 运单详情轨迹弹窗 -->
            <a-modal
                v-model="detailsopen"
                v-if="detailsopen"
                title="运单详情"
                @ok="detailsOk"
                width="50%"
            >
                <a-row>
                    <a-col :span="8"
                        >运单编号：{{ DetailsObject.serial }}</a-col
                    >
                    <a-col :span="8"
                        >运单时间：{{ DetailsObject.create_time }}</a-col
                    >
                    <a-col :span="8"
                        >司机：{{ DetailsObject.driver_name }}</a-col
                    >
                </a-row>

                <a-row :gutter="20">
                    <a-col :span="8"
                        >运单状态：{{ DetailsObject.order_status }}</a-col
                    >
                    <a-col :span="8"
                        >扎帐状态：{{ DetailsObject.is_accounting }}</a-col
                    >
                    <a-col :span="8"
                        >总重量：{{ DetailsObject.total_weight }}</a-col
                    >
                </a-row>
                <a-row :gutter="20">
                    <a-col :span="8">车牌号：{{ DetailsObject.number }}</a-col>
                    <a-col :span="8"
                        >送货地址：{{ DetailsObject.sorting_address }}</a-col
                    >
                    <a-col :span="8">
                        <div class="col_div">
                            清运照片：
                            <img
                                class="DetailsObject_img"
                                :src="DetailsObject.image"
                                alt=""
                            />
                        </div>
                    </a-col>
                </a-row>

                <div id="mapDiv"></div>
            </a-modal>
        </div>
    </content-view>
</template>

<script>
export default {
    name: "Newshowdata",
    data() {
        return {
            form: {
                today_cate_data: {
                    start_weight: "",
                    end_weight: "",
                    paper: "",
                    plastic: "",
                    metal: "",
                    textile: "",
                    glass: "",
                    electrical: "",
                },
                today_rank: [
                    {
                        name: "",
                        weight: "",
                        sort: 1,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 2,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 3,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 4,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 5,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 6,
                    },
                ],
                join_rate: [
                    {
                        name: "",
                        rate: "",
                        sort: 1,
                    },
                    {
                        name: "",
                        rate: "",
                        sort: 2,
                    },
                    {
                        name: "",
                        rate: "",
                        sort: 3,
                    },
                    {
                        name: "",
                        rate: "",
                        sort: 4,
                    },
                    {
                        name: "",
                        rate: "",
                        sort: 5,
                    },
                    {
                        name: "",
                        rate: "",
                        sort: 6,
                    },
                ],
                today_people: {
                    total: "",
                    online: "",
                },
                station: {
                    total: "",
                    online: "",
                },
                cars: {
                    total: "",
                    online: "",
                },
                sorting: {
                    total: "",
                    online: "",
                },
                pack_station: {
                    total: "",
                    online: "",
                },
                last_year_recycling: {
                    total: "",
                    paper: "",
                    plastic: "",
                    metal: "",
                    textile: "",
                    glass: "",
                    electrical: "",
                },
                last_year_per_month: {
                    january: "",
                    february: "",
                    march: "",
                    april: "",
                    may: "",
                    june: "",
                    july: "",
                    august: "",
                    september: "",
                    october: "",
                    november: "",
                    december: "",
                },
                last_month_rank: [
                    {
                        name: "",
                        weight: "",
                        sort: 1,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 2,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 3,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 4,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 5,
                    },
                    {
                        name: "",
                        weight: "",
                        sort: 6,
                    },
                ],
                last_week_avg_weight: {
                    monday: "",
                    tuesday: "",
                    wednesday: "",
                    thursday: "",
                    friday: "",
                    saturday: "",
                    sunday: "",
                },
            },
            rules: {
                today_cate_data: {
                    start_weight: {
                        required: true,
                        message: "请填写信息",
                    },
                    end_weight: {
                        required: true,
                        message: "请填写信息",
                    },
                    paper: {
                        required: true,
                        message: "请填写信息",
                    },
                    plastic: {
                        required: true,
                        message: "请填写信息",
                    },
                    metal: {
                        required: true,
                        message: "请填写信息",
                    },
                    textile: {
                        required: true,
                        message: "请填写信息",
                    },
                    glass: {
                        required: true,
                        message: "请填写信息",
                    },
                    electrical: {
                        required: true,
                        message: "请填写信息",
                    },
                },

                today_people: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    online: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                station: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    online: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                cars: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    online: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                sorting: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    online: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                pack_station: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    online: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                last_year_recycling: {
                    total: {
                        required: true,
                        message: "请填写信息",
                    },
                    paper: {
                        required: true,
                        message: "请填写信息",
                    },
                    plastic: {
                        required: true,
                        message: "请填写信息",
                    },
                    metal: {
                        required: true,
                        message: "请填写信息",
                    },
                    textile: {
                        required: true,
                        message: "请填写信息",
                    },
                    glass: {
                        required: true,
                        message: "请填写信息",
                    },
                    electrical: {
                        required: true,
                        message: "请填写信息",
                    },
                },
                last_year_per_month: {
                    january: {
                        required: true,
                        message: "请填写信息",
                    },
                    february: {
                        required: true,
                        message: "请填写信息",
                    },
                    march: {
                        required: true,
                        message: "请填写信息",
                    },
                    april: {
                        required: true,
                        message: "请填写信息",
                    },
                    may: {
                        required: true,
                        message: "请填写信息",
                    },
                    june: {
                        required: true,
                        message: "请填写信息",
                    },
                    july: {
                        required: true,
                        message: "请填写信息",
                    },
                    august: {
                        required: true,
                        message: "请填写信息",
                    },
                    september: {
                        required: true,
                        message: "请填写信息",
                    },
                    october: {
                        required: true,
                        message: "请填写信息",
                    },
                    november: {
                        required: true,
                        message: "请填写信息",
                    },
                    december: {
                        required: true,
                        message: "请填写信息",
                    },
                },

                last_week_avg_weight: {
                    monday: {
                        required: true,
                        message: "请填写信息",
                    },
                    tuesday: {
                        required: true,
                        message: "请填写信息",
                    },
                    wednesday: {
                        required: true,
                        message: "请填写信息",
                    },
                    thursday: {
                        required: true,
                        message: "请填写信息",
                    },
                    friday: {
                        required: true,
                        message: "请填写信息",
                    },
                    saturday: {
                        required: true,
                        message: "请填写信息",
                    },
                    sunday: {
                        required: true,
                        message: "请填写信息",
                    },
                },
            },
            visible: false,
            modalType: "",
            blockForm: {},
            blockList: [],
            selectedRowKeys: [],
            columns: [
                {
                    title: "网点名称",
                    dataIndex: "name",
                    key: "name",
                },
                {
                    title: "区域",
                    dataIndex: "district",
                    key: "district",
                },
                {
                    title: "地址",
                    dataIndex: "address",
                    key: "address",
                },
            ],
            page: 1,
            limit: 10,
            pagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0,
            },

            itemI: 0,
            selectedRowKeys: [],
            errtr: [
                //是对今日回收排行榜today_rate我缩写为tr是否输入设置的一个标识 err是输入框已填为1，未填为2，blockerr是点位已填为1，未填为2
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
            ],
            errjr: [
                //是对居民参与率排行join_rate我缩写为jr是否输入设置的一个标识 err是输入框已填为1，未填为2，blockerr是点位已填为1，未填为2
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
            ],
            errlr: [
                //是对近一月回收排行榜last_month_rate我缩写为lr是否输入设置的一个标识 err是输入框已填为1，未填为2，blockerr是点位已填为1，未填为2
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
                {
                    err: 1,
                    blockerr: 1,
                },
            ],
            flagtr: [
                //是对今日回收排行榜today_rate我缩写为tr是否输入设置的一个标识在最后循环判断是否已填 flag是记录输入框是否有数据未有为1，已有为2，blockflag是点位未选为1，已填为2
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
            ],
            flagjr: [
                //是对居民参与率排行join_rate我缩写为jr是否输入设置的一个标识在最后循环判断是否已填 flag是记录输入框是否有数据未有为1，已有为2，blockflag是点位未选为1，已填为2
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
            ],
            flaglr: [
                //是对近一月回收排行榜last_month_rate我缩写为lr是否输入设置的一个标识在最后循环判断是否已填 flag是记录输入框是否有数据未有为1，已有为2，blockflag是点位未选为1，已填为2
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
                {
                    flag: 2,
                    blockflag: 1,
                },
            ],
            noEntertr: [
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
            ],
            noEnterjr: [
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
            ],
            noEnterlr: [
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
                { no: 1 },
            ],
            NoEnter: 0,
            activeKey: 0,

            checkboxValue: [],
            weekListData: [],
            tdmap: "",
            tdzoom: 12,
            tdpoints: [],
            tablecolumns: [
                {
                    title: "序号",
                    dataIndex: "index",
                    width: 60,
                    align: "center",
                    customRender: (text, record, index) => {
                        // index 是当前行的索引，从 0 开始，+1 使其从 1 开始计数
                        return index + 1;
                    },
                },
                {
                    title: "目的地",
                    dataIndex: "sorting_address",
                    key: "sorting_address",
                },
                {
                    title: "清运点位",
                    dataIndex: "block_num",
                    key: "block_num",
                },
                {
                    title: "车牌号",
                    dataIndex: "car_number",
                    key: "car_number",
                },
                {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                    scopedSlots: { customRender: "action" },
                    // ellipsis: true,
                },
            ],
            tabledata: [],
            transportopen: false,
            transportcolumns: [
                {
                    title: "",
                    dataIndex: "",
                    key: "",
                    scopedSlots: { customRender: "check" },
                    width: 80,
                },
                {
                    title: "运单号",
                    dataIndex: "serial",
                    key: "serial",
                },
                {
                    title: "目的地",
                    dataIndex: "sorting_address",
                    key: "sorting_address",
                },
                {
                    title: "清运点位数",
                    dataIndex: "block_num",
                    key: "block_num",
                },
                {
                    title: "清运点位",
                    dataIndex: "block_name",
                    key: "block_name",
                },
                {
                    title: "车牌号",
                    dataIndex: "car_number",
                    key: "car_number",
                },
                {
                    title: "规划里程",
                    dataIndex: "distance",
                    key: "distance",
                    scopedSlots: { customRender: "distance" },
                    ellipsis: true,
                },
            ],
            transportdata: [],
            transportpagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0,
            },
            addtransportFrom: {},
            transportpage: 1,
            transportlimit: 10,
            detailsopen: false,
            DetailsObject: {},
        };
    },

    methods: {
        // tabs
        tabschange() {
            this.tabledata = [];
            this.getDetail();
        },
        // 运单详情
        gettransportOrderDetail(item) {
            let that = this;
            this.$api.newshowdata
                .transportOrderDetail({
                    serial: item.serial,
                })
                .then((res) => {
                    that.DetailsObject = res.data;
                    setTimeout(() => {
                        that.onLoad();
                    }, 100);
                });
        },
        // 开启运单详情弹窗
        detailsClick(item) {
            this.detailsopen = true;
            if (this.tdmap) {
                // 移除所有覆盖物
                this.tdmap.clearOverLays();
                // 解绑所有事件监听
                this.tdmap.off();
                // 销毁地图实例（天地图官方方法）
                if (typeof this.tdmap.destroy === "function") {
                    this.tdmap.destroy();
                }
                // 清空地图容器DOM（关键：避免残留事件）
                const mapContainer = document.getElementById("mapDiv");
                if (mapContainer) {
                    mapContainer.innerHTML = "";
                }
                // 重置地图相关变量
                this.tdmap = null;
                this.tdpoints = [];
            }
            this.gettransportOrderDetail(item);
        },
        //
        detailsOk() {
            this.detailsopen = false;
        },
        // 车辆轨迹删除
        deleteTable(item) {
            this.tabledata.splice(item, 1);
        },
        // 物流运单分页
        transportpageChange(pagination) {
            this.$set(this.transportpagination, "current", pagination.current);
            this.$set(
                this.transportpagination,
                "pageSize",
                pagination.pageSize
            );
            this.transportpage = pagination.current;
            this.transportlimit = pagination.pageSize;
            this.gettransportOrderList();
        },
        // 物流运单搜索
        transportsearch() {
            this.gettransportOrderList();
        },
        // 物流运单重置
        transportreset() {
            this.addtransportFrom = {};
            this.gettransportOrderList();
        },
        // 添加
        addClick() {
            this.transportopen = true;
            this.gettransportOrderList();
        },
        transporthandleOk() {
            this.tabledata = [];
            this.transportdata.forEach((element, index) => {
                if (element.checked) {
                    this.tabledata.push(element);
                }
            });
            this.transportopen = false;
        },
        // 物流运单列表
        gettransportOrderList() {
            this.addtransportFrom.page = this.transportpage;
            this.addtransportFrom.limit = this.transportlimit;
            this.$api.newshowdata
                .transportOrderList(this.addtransportFrom)
                .then((res) => {
                    this.transportpagination.total = res.total * 1;
                    this.transportdata = res.data.list;
                });
        },
        // 初始化天地图
        onLoad() {
            //初始化地图对象
            this.tdmap = new T.Map("mapDiv");
            let that = this;
            //设置显示地图的中心点和级别
            this.tdmap.centerAndZoom(
                new T.LngLat(
                    that.DetailsObject.coor[0].longitude * 1
                        ? that.DetailsObject.coor[0].longitude * 1
                        : "",
                    that.DetailsObject.coor[0].latitude * 1
                        ? that.DetailsObject.coor[0].latitude * 1
                        : ""
                ),
                this.tdzoom
            );
            this.tdpoints = [];
            this.DetailsObject.coor.forEach((element) => {
                this.tdpoints.push(
                    new T.LngLat(element.longitude * 1, element.latitude * 1)
                );
            });
            //创建线对象
            var line = new T.Polyline(this.tdpoints);
            //向地图上添加线
            this.tdmap.addOverLay(line);
            //创建图片对象
            var passicon = new T.Icon({
                iconUrl:
                    "https://jiabaotu.oss-cn-hangzhou.aliyuncs.com/datamanage/pass.png",
                iconSize: new T.Point(32, 36),
                iconAnchor: new T.Point(0, 0),
            });
            var noPassicon = new T.Icon({
                iconUrl:
                    "https://jiabaotu.oss-cn-hangzhou.aliyuncs.com/datamanage/noPass.png",
                iconSize: new T.Point(32, 36),
                iconAnchor: new T.Point(0, 0),
            });
            //向地图上添加自定义标注
            var passmarker = new T.Marker(this.tdpoints[0], { icon: passicon });
            var noPassmarker = new T.Marker(
                this.tdpoints[this.tdpoints.length - 1],
                { icon: noPassicon }
            );

            this.tdmap.addOverLay(passmarker);
            this.tdmap.addOverLay(noPassmarker);
        },
        //
        checkboxchange() {
            this.getselectWeekDefault();
        },
        // 获取星期别表
        getweekList() {
            this.checkboxValue = [];
            this.$api.newshowdata.weekList().then((res) => {
                if (res.data.error_no) {
                    this.$message.error(res.msg);
                } else {
                    this.weekListData = res.data.list;
                    this.weekListData.forEach((element) => {
                        if (element.is_use_default * 1 === 1) {
                            this.checkboxValue.push(element.value);
                        }
                    });
                }
            });
        },
        // 设置星期默认值
        getselectWeekDefault() {
            this.$api.newshowdata
                .selectWeekDefault({ week: this.checkboxValue.join(",") })
                .then((res) => {
                    if (res.data.error_no) {
                        this.$message.error(res.msg);
                    } else {
                        this.$message.success(res.msg);
                    }
                });
        },
        inputChangetr(i) {
            if (this.form.today_rank[i].weight == "") {
                this.errtr[i].err = 2; //当输入框变化的时候，重量为空，则标记err，显示请输入数据
                this.flagtr[i].flag = 1; //同时记录未输入，以便提交时判断是否有空
            } else {
                this.flagtr[i].flag = 2; // 如果不为空则取消标记
                this.errtr[i].err = 1;
            }
        },
        inputChangejr(i) {
            if (this.form.join_rate[i].rate == "") {
                this.errjr[i].err = 2; //同上
                this.flagjr[i].flag = 1;
            } else {
                this.flagjr[i].flag = 2;
                this.errjr[i].err = 1;
            }
        },
        inputChangelr(i) {
            if (this.form.last_month_rank[i].weight == "") {
                this.errlr[i].err = 2; //同上
                this.flaglr[i].flag = 1;
            } else {
                this.errlr[i].err = 1;
                this.flaglr[i].flag = 2;
            }
        },
        handleSubmit(e) {
            for (let i = 0; i < 6; i++) {
                //循环判断是否有未选择点位，如果有则blockerr=2显示请输入信息，用noEntertr今日回收，noEnterjr为居民参与率，noEnterlr为近一月回收
                this.inputChangetr(i);
                this.inputChangejr(i);
                this.inputChangelr(i);
                if (this.flagtr[i].flag == 1) {
                    this.errtr[i].err = 2;
                    this.noEntertr[i].no = 1;
                }
                if (this.flagtr[i].blockflag == 1) {
                    this.noEntertr[i].no = 1;
                    this.errtr[i].blockerr = 2;
                }
                if (this.flagtr[i].flag == 2 && this.flagtr[i].blockflag == 2) {
                    this.noEntertr[i].no = 0;
                    this.errtr[i].blockerr = 1;
                    this.errtr[i].err = 1;
                }
                if (this.flagjr[i].flag == 1) {
                    this.errjr[i].err = 2;
                    this.noEnterjr[i].no = 1;
                }
                if (this.flagjr[i].blockflag == 1) {
                    this.noEnterjr[i].no = 1;
                    this.errjr[i].blockerr = 2;
                }
                if (this.flagjr[i].flag == 2 && this.flagjr[i].blockflag == 2) {
                    this.noEnterjr[i].no = 0;
                    this.errjr[i].blockerr = 1;
                    this.errjr[i].err = 1;
                }
                if (this.flaglr[i].flag == 1) {
                    this.errlr[i].err = 2;
                    this.noEnterlr[i].no = 1;
                }
                if (this.flaglr[i].blockflag == 1) {
                    this.noEnterlr[i].no = 1;
                    this.errlr[i].blockerr = 2;
                }
                if (this.flaglr[i].flag == 2 && this.flaglr[i].blockflag == 2) {
                    this.noEnterlr[i].no = 0;
                    this.errlr[i].blockerr = 1;
                    this.errlr[i].err = 1;
                }
            }
            this.NoEnter = 0;
            for (let i = 0; i < 6; i++) {
                if (
                    this.noEntertr[i].no == 1 ||
                    this.noEnterjr[i].no == 1 ||
                    this.noEnterlr[i].no == 1
                ) {
                    this.NoEnter = 1;
                    break;
                } else {
                    this.NoEnter = 0;
                }
            }
            console.log("this.NoEnter", this.NoEnter);
            this.$refs.formRef.validate((valid) => {
                if (this.NoEnter == 0) {
                    if (valid) {
                        console.log("eee", e);
                        let parmas = {
                            today_rank: JSON.stringify(this.form.today_rank),
                            today_cate_data: JSON.stringify(
                                this.form.today_cate_data
                            ),
                            join_rate: JSON.stringify(this.form.join_rate),
                            today_people: JSON.stringify(
                                this.form.today_people
                            ),
                            station: JSON.stringify(this.form.station),
                            cars: JSON.stringify(this.form.cars),
                            sorting: JSON.stringify(this.form.sorting),
                            pack_station: JSON.stringify(
                                this.form.pack_station
                            ),
                            last_year_recycling: JSON.stringify(
                                this.form.last_year_recycling
                            ),
                            last_year_per_month: JSON.stringify(
                                this.form.last_year_per_month
                            ),
                            last_month_rank: JSON.stringify(
                                this.form.last_month_rank
                            ),
                            last_week_avg_weight: JSON.stringify(
                                this.form.last_week_avg_weight
                            ),
                            transport_car: JSON.stringify(this.tabledata),
                            week: this.activeKey,
                        };
                        this.$api.newshowdata
                            .screenShowSet(parmas)
                            .then((res) => {
                                if (res.data.error_no) {
                                    this.$message.error(res.msg);
                                } else {
                                    this.$message.success(res.msg);
                                }
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                } else {
                    this.$message.error("请填写信息！");
                }
            });
        },
        handleCancel() {
            this.visible = false;
        },
        handleOk() {
            this.visible = false;
            this.selectedRowKeys = [];
        },
        //网点搜索重置
        reset() {
            this.page = 1;
            this.limit = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.$refs.pa.reset();
            this.getList();
        },
        //网点搜索查询
        search() {
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.page = 1;
            this.limit = 10;
            this.getList(true);
        },
        //获得网点列表
        //page:页 limit每页条数
        getList(status = false) {
            this.blockForm.page = this.page;
            this.blockForm.limit = this.limit;
            this.$api.newshowdata
                .screenShowStation(this.blockForm)
                .then((res) => {
                    this.pagination.total = res.total * 1;
                    this.blockList = res.data.list;
                    status
                        ? this.$message.success(
                              "共查询到" + res.total + "条信息"
                          )
                        : "";
                });
        },

        // 分页
        pageChange(pagination) {
            this.$set(this.pagination, "current", pagination.current);
            this.$set(this.pagination, "pageSize", pagination.pageSize);
            this.page = pagination.current;
            this.limit = pagination.pageSize;
            this.getList();
        },
        today(i) {
            this.visible = true;
            this.itemI = i;
            this.modalType = "today";
        },
        rate(i) {
            this.visible = true;
            this.itemI = i;
            this.modalType = "rate";
        },
        last(i) {
            this.visible = true;
            this.itemI = i;
            this.modalType = "last";
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys;
            if (this.modalType == "today") {
                if (selectedRowKeys != "") {
                    this.form.today_rank[this.itemI].name =
                        selectedRows[0].name;
                    this.flagtr[this.itemI].blockflag = 2;
                    this.errtr[this.itemI].blockerr = 1;
                } else {
                    this.form.today_rank[this.itemI].name = "";
                    this.flagtr[this.itemI].blockflag = 1;
                }
            } else if (this.modalType == "rate") {
                if (selectedRowKeys != "") {
                    this.form.join_rate[this.itemI].name = selectedRows[0].name;
                    this.flagjr[this.itemI].blockflag = 2;
                    this.errjr[this.itemI].blockerr = 1;
                } else {
                    this.form.join_rate[this.itemI].name = "";
                    this.flagjr[this.itemI].blockflag = 1;
                }
            } else if (this.modalType == "last") {
                if (selectedRowKeys != "") {
                    this.form.last_month_rank[this.itemI].name =
                        selectedRows[0].name;
                    this.flaglr[this.itemI].blockflag = 2;
                    this.errlr[this.itemI].blockerr = 1;
                } else {
                    this.form.last_month_rank[this.itemI].name = "";
                    this.flaglr[this.itemI].blockflag = 0;
                }
            }
        },
        // 回显
        getDetail() {
            this.$api.newshowdata
                .screenShowInfo({ week: this.activeKey })
                .then((res) => {
                    this.form.today_rank = JSON.parse(res.data.today_rank);
                    this.form.today_cate_data = JSON.parse(
                        res.data.today_cate_data
                    );
                    this.form.join_rate = JSON.parse(res.data.join_rate);
                    this.form.today_people = JSON.parse(res.data.today_people);
                    this.form.station = JSON.parse(res.data.station);
                    this.form.cars = JSON.parse(res.data.cars);
                    this.form.sorting = JSON.parse(res.data.sorting);
                    this.form.pack_station = JSON.parse(res.data.pack_station);
                    this.form.last_year_recycling = JSON.parse(
                        res.data.last_year_recycling
                    );
                    this.form.last_year_per_month = JSON.parse(
                        res.data.last_year_per_month
                    );
                    this.form.last_month_rank = JSON.parse(
                        res.data.last_month_rank
                    );
                    this.form.last_week_avg_weight = JSON.parse(
                        res.data.last_week_avg_weight
                    );
                    if (res.data.transport_car) {
                        this.tabledata = JSON.parse(res.data.transport_car);
                    }
                    for (let i = 0; i < 6; i++) {
                        if (this.form.join_rate[i].name == "") {
                            this.flagjr[i].blockflag = 1;
                        } else {
                            this.flagjr[i].blockflag = 2;
                        }
                        if (this.form.today_rank[i].name == "") {
                            this.flagtr[i].blockflag = 1;
                        } else {
                            this.flagtr[i].blockflag = 2;
                        }
                        if (this.form.last_month_rank[i].name == "") {
                            this.flaglr[i].blockflag = 1;
                        } else {
                            this.flaglr[i].blockflag = 2;
                        }
                    }
                });
            for (let i = 0; i < 6; i++) {
                //循环判断是否有未选择点位，如果有则blockerr=2显示请输入信息，用noEntertr今日回收，noEnterjr为居民参与率，noEnterlr为近一月回收
                if (this.flagtr[i].flag == 1) {
                    this.noEntertr[i].no = 1;
                }
                if (this.flagtr[i].blockflag == 1) {
                    this.noEntertr[i].no = 1;
                }
                if (this.flagtr[i].flag == 2 && this.flagtr[i].blockflag == 2) {
                    this.noEntertr[i].no = 0;
                }
                if (this.flagjr[i].flag == 1) {
                    this.noEnterjr[i].no = 1;
                }
                if (this.flagjr[i].blockflag == 1) {
                    this.noEnterjr[i].no = 1;
                }
                if (this.flagjr[i].flag == 2 && this.flagjr[i].blockflag == 2) {
                    this.noEnterjr[i].no = 0;
                }
                if (this.flaglr[i].flag == 1) {
                    this.noEnterlr[i].no = 1;
                }
                if (this.flaglr[i].blockflag == 1) {
                    this.noEnterlr[i].no = 1;
                }
                if (this.flaglr[i].flag == 2 && this.flaglr[i].blockflag == 2) {
                    this.noEnterlr[i].no = 0;
                }
            }
        },
    },
    computed: {},
    created() {
        this.getweekList();
        this.getList();
        this.getDetail();
    },
    mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss">
#mapDiv {
    width: 100%;
    height: 300px;
    margin-top: 30px;
}
.wrap-container > div {
    flex: auto;
}
.showdata {
    .bold {
        font-weight: bold;
    }
    .ant-upload.ant-upload-drag {
        height: 202px;
    }
    .ant-upload.ant-upload-drag .ant-upload {
        padding: 0;
    }
    .icon-add {
        font-size: 40px;
    }
    .image {
        height: 200px;
    }
    .ant-checkbox-wrapper {
        width: 175px;
    }
    .editbtn {
        color: rgba(8, 106, 204, 1);
    }
}
.ql-picker,
.ql-picker-label {
    line-height: 24px;
}
.circle-wrapper {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: lightgray;
    text-align: center;
    line-height: 20px;
}
</style>
